import { currentBrand } from '../../../brandConfig';
import { joinQueryParams } from '../../../url';
import { DEFAULT_IMAGE_EXTENSION, XXL_SUFFIX, AKAMAI_PREFIX, AKAMAI_DAM_PREFIX } from './constants';
/**
 * This function returns the akamai url for an image.
 * @param {string} - id of the image as defined in hybris.
 * @param {boolean} - isDamImage. Defines if the image is DAM
 * @param {string|number} - width. Will be used to specify the imwidth paramater for Akamai.
 * @param {string|number} - height. Will be used to specify the imheight parameter for Akamai
 * @return {string} the akamai image url
 */
export const imageIdToAkamaiSrc = (id, isDamImage, width, height) => {
    const PATH_TO_USE = isDamImage ? AKAMAI_DAM_PREFIX : AKAMAI_PREFIX;
    const rootUrl = currentBrand ? PATH_TO_USE[currentBrand] : PATH_TO_USE.hm;
    const extension = isDamImage ? '' : DEFAULT_IMAGE_EXTENSION;
    const suffix = isDamImage ? '' : XXL_SUFFIX;
    const imWidth = width ? `imwidth=${width}` : undefined;
    const imHeight = height ? `imheight=${height}` : undefined;
    const queryParams = joinQueryParams(imWidth, imHeight);
    let returnUrl;
    if (id.includes('/')) {
        returnUrl = `${rootUrl}${id}${suffix}${extension}${queryParams}`;
    }
    else {
        const dir1 = id.substr(0, 2);
        const dir2 = id.substr(2, 2);
        returnUrl = `${rootUrl}/${dir1}/${dir2}/${id}${suffix}${extension}${queryParams}`;
    }
    return returnUrl;
};
//# sourceMappingURL=imageIdToAkamaiSrc.js.map